import { action, computed, observable } from 'mobx';
import { SerializedData, Store } from 'bernie-core';
import {
  FlightsLoadedPriceSummaryType,
  FlightsLoadingPriceSummaryType,
  FlightsSummaryType
} from 'types/information/price-summary/price-summary';

export class PriceSummaryStore extends Store {
  @observable public priceSummary: FlightsSummaryType;

  @computed get skeletonCount(): number {
    return (
      this.priceSummary &&
      this.priceSummary.__typename === 'FlightsLoadingPriceSummary' &&
      (this.priceSummary as FlightsLoadingPriceSummaryType).skeletonCount
    );
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public setPriceSummary = (priceSummary: FlightsLoadedPriceSummaryType) => {
    if (priceSummary) {
      this.priceSummary = priceSummary;
    }
  };
}
